import { render, staticRenderFns } from "./SelectAjax.vue?vue&type=template&id=e2b2c136&"
import script from "./SelectAjax.vue?vue&type=script&lang=js&"
export * from "./SelectAjax.vue?vue&type=script&lang=js&"
import style0 from "./SelectAjax.vue?vue&type=style&index=0&id=e2b2c136&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports